import { IPartnerParams } from '@/partners/partnerTypes';

import { postUrl } from '../fetch';

// note: This doesn't return IPartnerParams but PartnerConfig
export async function lookupVroomCode(
    vroomCode: string | undefined,
    storeId: string | undefined | null
): Promise<IPartnerParams | void> {
    try {
        const url = `/api/partner/partnerConfigFromVroomCode`;
        const response = await postUrl<any>(url, { vroomCode, storeId });
        const partnerConfig = response;
        return partnerConfig;
    } catch (err) {
        console.log(err);
        return;
    }
}
